<template>
  <div
    class="sg-card border-radius-md"
    :class="{ expanded: expanded,
              expandedItems: expanded, }"
  >
    <div class="sg-card-content p-t-1">
      <h2
        class="sg-card-name fontSize-body fullWidth"
        :class="{expandedName: expanded }"
        :style="
          { color: color && titleColorIsGroupColor === 'true' ? color : 'rgb(0, 0, 0,.8)' }
        "
      >
        {{ group.Name }}
      </h2>
      <p
        class="sg-card-campus fontSize-xs fullWidth"
      >
        {{ group.Campus }}
      </p>
      <div
        v-if="!expanded && tagAttributeIds.slice(',').length > 0"
        class="tagList"
      >
        <div
          v-for="a in attributeValues(tagAttributeIds)"
          :key="a.Key"
          class="tag"
          :class="{ expandedTag: expanded }"
        >
          {{ a.FormattedValue }}
        </div>
      </div>
      <div class="row">
        <div
          :class="!expanded ? 'col-md-12': 'col-md-6'"
        >
          <p
            class="sg-card-description"
          >
            {{ truncate(group.Description, 120, true) }}
          </p>
          <div
            v-if="expanded && getGroupLeaders.length > 0"
          >
            <p class="smallHeading">
              {{ pluralizeText('Leader',getGroupLeaders.length) }}:
            </p>
            <ul
              style="list-style: none;"
            >
              <li
                v-for="leader in getGroupLeaders"
                :key="`${leader.NickName}-${leader.LastName}`"
              >
                {{ leader.NickName }} {{ leader.LastName }}
              </li>
            </ul>
          </div>
          <div v-if="expanded">
            <div
              v-for="a in attributeValues(descriptionAttributeIds)"
              :key="a.Key"
            >
              <p class="smallHeading">
                {{ a.Attribute.Name }}
              </p>
              <p style="margin-left:24px;" v-html="a.FormattedValue" />
            </div>
          </div>
          <div
            v-if="!expanded"
            class="description-fade"
          />
        </div>
        <div
          v-if="expanded"
          class="col-md-6"
          style="display: flex;
                  flex-direction: column;
                  justify-items: flex-start;
                  justify-content: flex-start;
                  align-content: flex-start;
                  flex-wrap: wrap;"
        >
          <google-Map
            v-if="group.MeetingLocations[0] && showMap === 'true' && apiKey && !this.addressIsEmpty"
            :street1="group.MeetingLocations[0].Street1"
            :street2="group.MeetingLocations[0].Street2"
            :city="group.MeetingLocations[0].City"
            :state="group.MeetingLocations[0].State"
            :zip-code="group.MeetingLocations[0].PostalCode"
            :api-key="apiKey"
          />
          <div
            class="tagList"
          >
            <div
              v-for="a in attributeValues(tagAttributeIds)"
              :key="a.Key"
              class="tag"
              :class="{ expandedTag: expanded }"
            >
              {{ a.FormattedValue }}
            </div>
          </div>
          <div style="width:100%;">
            <a
              v-if="expanded"
              style="color:white;
                margin-bottom:20px;
                display:block;
                align-self:stretch;
                width:100%;"
              class="btn btn-primary sign-Up-Link"
              :href="`${signUpPage}?GroupGuid=${ group.Guid }`"
            >
              Sign Up!
            </a>
          </div>
        </div>
      </div>

      <a
        class="more-info-text"
        @click="expanded = !expanded"
      >
        {{ !expanded ? `More Info`: 'Hide Details' }}
      </a>
    </div>
    <div class="sg-card-side-bar">
      <div
        class="sg-card-meta"
        :style="{ backgroundColor: color ? color : 'rgb(140, 140, 140)' }"
      >
        <div
          class="fontSize-body sg-day-of-week"
          style="font-weight:bold;"
        >
          {{ group.DayOfWeek }}
        </div>
        <div
          v-if="showTime === 'true'"
          class="fontSize-xxs"
        >
          {{ group.TimeOfDay }}
        </div>
        <div
          v-if="showFrequency == 'true'"
          class="fontSize-xxs"
        >
          {{ group.Frequency }}
        </div>
        <div
          v-for="a in attributeValues(colorAreaAttributeIds)"
          :key="a.Key"
        >
          {{ a.FormattedValue }}
        </div>
      </div>
      <div
        class="sg-card-info m-b-half"
      >
        <div
          v-if="showPrimaryAttributeFirst === 'true'"
          :style="{ color: color }"
          style="font-weight:bold;"
        >
          {{ getPrimaryAtribute.FormattedValue }}
        </div>
        <div
          v-for="a in attributeValues(displayAttributeIds)"
          :key="a.Key"
        >
          {{ a.FormattedValue }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pluralize from 'pluralize';
import googleMap from './googleMap.vue';

export default {
  name: 'GroupItem',
  components: {
    googleMap,
  },
  props: {
    signUpPage: {
      type: String,
      required: true,
      default: '',
    },
    displayAttributeIds: {
      type: String,
      required: false,
      default: '',
    },
    group: {
      type: Object,
      required: true,
      default: () => {},
    },
    color: {
      type: String,
      required: true,
      default: 'rgb(140, 140, 140)',
    },
    primaryAttributeId: {
      type: String,
      required: false,
      default: null,
    },
    titleColorIsGroupColor: {
      type: String,
      required: true,
      default: 'false',
    },
    showTime: {
      type: String,
      required: false,
      default: 'true',
    },
    showFrequency: {
      type: String,
      required: false,
      default: 'true',
    },
    colorAreaAttributeIds: {
      type: String,
      required: false,
      default: '',
    },
    tagAttributeIds: {
      type: String,
      required: false,
      default: '',
    },
    showPrimaryAttributeFirst: {
      type: String,
      required: false,
      default: 'true',
    },
    showLeaders: {
      type: String,
      required: 'false',
      default: 'false',
    },
    descriptionAttributeIds: {
      type: String,
      required: false,
      default: '',
    },
    groupRoleIds: {
      type: String,
      required: false,
      default: '',
    },
    showMap: {
      type: String,
      required: false,
      default: 'false',
    },
    apiKey: {
      type: String,
      required: false,
      default: '',
    },
  },
  data: () => ({
    expanded: false,
  }),
  computed: {
    getAttributeAsArray() {
      return Object.values(this.group.AttributeValues);
    },
    getPrimaryAtribute() {
      if (!this.primaryAttributeId) return { FormattedValue: '' };
      const primartAttribute = this.getAttributeAsArray.find(
        (x) => x.AttributeId === parseInt(this.primaryAttributeId, 10),
      );
      return primartAttribute;
    },
    getGroupLeaders() {
      if (!this.group.GroupLeaders.length > 0 || this.showLeaders === 'false') return [];
      return this.group.GroupLeaders.filter((x) => this.groupRoleIds.slice(',').includes(x.RoleId));
    },
    addressIsEmpty() {
      return Object.values(this.group.MeetingLocations[0]).every((x) => x === null || x === '');
    },
  },
  watch: {
    expanded() {
      if (this.expanded) {
        this.$el.scrollIntoView(true, { behavior: 'smooth', block: 'start' });
      }
    },
  },
  methods: {
    attributeValues(Ids) {
      if (!Ids) return [];
      const attributeArray = Ids.split(',').map(Number);
      const attributes = this.getAttributeAsArray.filter((x) => attributeArray.includes(x.AttributeId) && x.FormattedValue !== '');
      // eslint-disable-next-line max-len
      console.log(attributes);
      return attributes
        .sort((a, b) => attributeArray
          .indexOf(a.AttributeId) - attributeArray.indexOf(b.AttributeId));
    },
    truncate(str, n, useWordBoundary) {
      if (!str || str.length === 0) return '';
      if (this.expanded) return str;
      if (str.length <= n) { return str; }
      const subString = str.substr(0, n - 1); // the original check
      return `${useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString} ...`;
    },
    pluralizeText(text, quantity) {
      return Pluralize(text, quantity);
    },
  },
};
</script>

<style scoped>
  .sg-card {
    display:flex;
    flex-direction:row;
    justify-content: space-between;
    height: 210px;
    background: #fff;
    border: 1px solid #f8f8f8;
    box-sizing: border-box;
    box-shadow: 0 1px 4px rgb(0 0 0 / 24%);
    height: 100%;
    max-width:calc(90vw - 24px);
  }
  .sg-card .sg-card-content {
    position:relative;
    padding-left: 16px;
    overflow-wrap: break-word;
    overflow: hidden;
    display:flex;
    flex-direction:column;
    padding-right:10px;
    flex-grow:1;
    justify-content: space-between;

  }
  .sg-card.expanded .sg-card-content {
    overflow: scroll;
  }
  .sg-card .sg-card-campus {
    color: #777779;
}
.sg-card .sg-card-name {
    font-size: clamp(1em, 1.5em, 2.5vw);
    margin-bottom: 4px;
    color: black;
    font-weight:600;
}
.fontSize-body {
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 1.56;
    letter-spacing: -0.1px;
}
.fontSize-xs {
    font-size: 16px;
}
   .sg-card .sg-card-description {
     flex-grow:1;
     justify-self: flex-start;
     font-size: 14px;
   }
  .sg-card-side-bar {
    display:flex;
    flex-direction:column;
    width:22%;
    flex-shrink:0;
    background-color: #eee;
  }
  .sg-card .sg-card-meta {
    border-top-right-radius: 4px;
    color: #fff;
    padding: 16px 4px;
    text-align:center;
    min-height: 68px;
  }
  .sg-card .sg-card-info {
    margin-top: 14px;
    line-height: 16px;
    display:flex;
    flex-direction:column;
    flex-grow:1;
    justify-content: flex-start;
    align-items: center;
  }
  .expanded {
    grid-row: span 3;
    grid-column: 1 / -1;
    /* height:100%; */
    min-height:max-content;
  }
  .more-info-text {
    justify-self:flex-end;
    z-index:10;
    margin-bottom:20px;
    text-align:center;
    align-self:center;
    font-size:1.1em;
    font-weight:500;
  }
  .sg-card .description-fade {
    background: -webkit-gradient(linear,left bottom,left top,
      color-stop(36.2%,#fff),color-stop(114.1%,hsla(0,0%,100%,0)));
    background: linear-gradient(
          1turn
          ,#fff 36.2%,hsla(0,0%,100%,0) 114.1%);
    position: absolute;
    height: 100px;
    width: 100%;
    bottom: -40px;
}
.sign-Up-Link {
  justify-self:flex-start;
}
.m-b-half > div {
  text-align:center;
}
.m-b-half > div + div {
  margin-top:8px;
}
/* .cardGrid {
  display:grid;
  grid-template-columns: repeat( auto-fill, minmax(clamp(250px, 50%, 600px), 1fr) );
  flex-grow: 1;
} */
.fullWidth {
  grid-column: -1 / 1;
}
.tag {
    background-color: lightgray;
    display: inline-block;
    padding: .25vw 2vw;
    margin-bottom: 10px;
    border-radius: 5px;
    color: white;
    flex-grow: 0;
    align-self: flex-start;
    font-size: .75em;
    color: black;
}
.smallHeading {
  font-weight:600;
  font-size:1.1em;
  margin-bottom:0;
}
.tagList {
  display:flex;
  flex-direction:row;
  flex-wrap: wrap;
  justify-content:flex-start;
}
.tagList div {
  margin-right:10px;
}
.tag.expandedTag {
  font-size: 1em;
}
/* .expandedItems {
  position:fixed;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
  z-index: 100; */
  /* height:400px; */
  /* height: min-content;
  width: clamp(400px, 80vw, 820px);
} */
.fullWidth .sg-card-description {
  min-height: min-content;
}
.expanded .cardGrid {
  min-height:300px;
}
</style>
